import { CALL_SORTED_API } from 'gwx-voyager-components';
import SubscriptionSchema from './subscriptions.schema';

const validateSubscription = (body) => (dispatch) => dispatch({
    [CALL_SORTED_API]: {
        types: ['VALIDATE_SUBSCRIPTION_REQUEST', 'VALIDATE_SUBSCRIPTION_SUCCESS', 'VALIDATE_SUBSCRIPTION_FAILURE'],
        endpoint: `subscriptions/validateSubscription`,
        body,
        method: 'POST',
		schema: SubscriptionSchema.VALIDATE_SUBSCRIPTION,
		mapActionToStateKey: 'validateSubscription'
    }
});

const postSubscription = (body) => ({
	[CALL_SORTED_API]: {
		types: ['CREATE_SUBSCRIPTION_REQUEST', 'CREATE_SUBSCRIPTION_SUCCESS', 'CREATE_SUBSCRIPTION_FAILURE'],
		endpoint: 'subscriptions',
		body,
		method: 'POST',
		schema: SubscriptionSchema.CREATED_SUBSCRIPTIONS,
		mapActionToStateKey: 'createdSubscriptions'
	}
});

const postNpiComment = (body) => ({
	[CALL_SORTED_API]: {
		types: ['CREATE_NPI_COMMENT_REQUEST', 'CREATE_NPI_COMMENT_SUCCESS', 'CREATE_NPI_COMMENT_FAILURE'],
		endpoint: 'npicomments',
		body,
		method: 'POST',
		schema: SubscriptionSchema.CREATED_SUBSCRIPTIONS,
		mapActionToStateKey: 'createdNpiComment'
	}
});

const createNPIComment = (body) => (dispatch) => dispatch(postNpiComment(body));

const putNpiComment = (npiCommentId, body) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types:['UPDATE_NPI_COMMENT_REQUEST','UPDATE_NPI_COMMENT_SUCCESS','UPDATE_NPI_COMMENT_FAILURE'],
		endpoint: `npicomments/${npiCommentId}`,
		schema: SubscriptionSchema.SUBSCRIPTION,
		method: 'PUT',
		body
	}
});

const updateNpiComment = (npiCommentId, body) => (dispatch) => dispatch(putNpiComment(npiCommentId, body));

const deleteNpiComment = (npiCommentId) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ['DELETE_NPI_COMMENT_REQUEST','DELETE_NPI_COMMENT_SUCCESS','DELETE_NPI_COMMENT_FAILURE'],
		endpoint: `npicomments/${npiCommentId}`,
		schema: SubscriptionSchema.SUBSCRIPTIONS,
		method: 'POST'
	}
});

const createSubscription = (body) => (dispatch) => dispatch(postSubscription(body));

const createSubscriptions = (opportunities) => (dispatch) => (
	Promise.all(opportunities.map((opp) => (
		dispatch(createSubscription({
			npi: opp.providerNpi,
			sendingFacilityId: opp.sendingFacilityId,
			hpdAddresses: opp.directAddresses,
			manualAddressesLst : opp.manualAddressesLst,
			nppesDirectAddresses:opp.nppesDirectAddresses,
			hpdNppesDirectAddresses: opp.hpdNppesDirectAddresses,
			providerSubscriptionStatusDocumentId: opp.providerSubscriptionStatusDocumentId
		}))
	)))
);
const GET_SUBSCRIPTIONS=[
	'SUBSCRIPTIONS_REQUEST',
	'SUBSCRIPTIONS_SUCCESS',
	'SUBSCRIPTIONS_FAILURE']

const postAdhocSubscription = (body) => ({
	[CALL_SORTED_API]: {
		types: ['CREATE_ADHOC_SUBSCRIPTION_REQUEST', 'CREATE_ADHOC_SUBSCRIPTION_SUCCESS', 'CREATE_ADHOC_SUBSCRIPTION_FAILURE'],
		endpoint: 'subscriptions/adHoc',
		body,
		method: 'POST',
		schema: SubscriptionSchema.CREATED_ADHOC_SUBSCRIPTIONS,
		mapActionToStateKey: 'createdAdhocSubscriptions'
	}
});

const createAdhocSubscription = (body) => (dispatch) => dispatch(postAdhocSubscription(body));

const fetchSubscriptions = (communityId, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: GET_SUBSCRIPTIONS,
		endpoint: 'subscriptions',
		schema: SubscriptionSchema.SUBSCRIPTIONS,
		query,
		mapActionToStateKey: 'subscriptions'
	}
});

const sendResubscribeEmail = (subscriptionId) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ['RESUBSCRIBE_EMAIL_REQUEST', 'RESUBSCRIBE_EMAIL_SUCCESS', 'RESUBSCRIBE_EMAIL_FAILURE'],
		endpoint: `subscriptions/${subscriptionId}/sendResubscribeEmail`,
		schema: SubscriptionSchema.SUBSCRIPTION,
		method: 'POST'
	}
});

const updateSubscription = (subscriptionId,
	body, types, communityId, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types,
		endpoint: `subscriptions/${subscriptionId}`,
		schema: SubscriptionSchema.SUBSCRIPTION,
		method: 'PUT',
		query,
		body
	}
});

const SUBSCRIPTION_OPT_IN = [
	'SUBSCRIPTIONS_OPT_IN_REQUEST', 'SUBSCRIPTIONS_OPT_IN_SUCCESS', 'SUBSCRIPTIONS_OPT_IN_FAILURE'
];

const subscriptionOptIn = (subscriptionId, communityId, query) => (dispatch) => dispatch(updateSubscription(subscriptionId, { sendingFacilitySubscriptionStatus: 'OPT_IN' }, SUBSCRIPTION_OPT_IN, communityId, query));

const SUBSCRIPTION_OPT_OUT = [
	'SUBSCRIPTIONS_OPT_OUT_REQUEST', 'SUBSCRIPTIONS_OPT_OUT_SUCCESS', 'SUBSCRIPTIONS_OPT_OUT_FAILURE'
];

const subscriptionOptOut = (subscriptionId, communityId, query) => (dispatch) => dispatch(updateSubscription(subscriptionId, { sendingFacilitySubscriptionStatus: 'OPT_OUT' }, SUBSCRIPTION_OPT_OUT, communityId, query));

const SUBSCRIPTION_DELETE = [
	'SUBSCRIPTIONS_DELETE_REQUEST',	'SUBSCRIPTIONS_DELETE_SUCCESS',	'SUBSCRIPTIONS_DELETE_FAILURE'
];
const deleteSubscription = (subscriptionId, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: SUBSCRIPTION_DELETE,
		endpoint: `subscriptions/${subscriptionId}`,
		schema: SubscriptionSchema.SUBSCRIPTIONS,
		method: 'POST',
		query
	}
});

const SUBSCRIPTION_DELETE_WITH_STATUS = [
	'SUBSCRIPTION_DELETE_WITH_STATUS_REQUEST', 'SUBSCRIPTION_DELETE_WITH_STATUS_SUCCESS', 'SUBSCRIPTION_DELETE_WITH_STATUS_FAILURE'
];
const deleteSubscriptionWithStatus = (id, communityId, isActive, deleteMultiple, query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: SUBSCRIPTION_DELETE_WITH_STATUS,
		endpoint: `subscriptions/${id}/delete`,
		schema: SubscriptionSchema.SUBSCRIPTIONS,
		method: 'PUT',
		query: {
			...query,
			id,
			communityId,
			isActive,
			deleteMultiple
		},
		mapActionToStateKey: 'subscriptions'
	}
});

const validateAddress = (query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ['VALIDATE_ADDRESS_REQUEST', 'VALIDATE_ADDRESS_SUCCESS', 'VALIDATE_ADDRESS_FAILURE'],
		endpoint: `subscriptions/validateAddress`,
		schema: SubscriptionSchema.VALIDATE_ADDRESS,
		query,
		mapActionToStateKey: 'directAddressValidation'
	}
});

const validateNPI = (query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ['VALIDATE_NPI_REQUEST', 'VALIDATE_NPI_SUCCESS', 'VALIDATE_NPI_FAILURE'],
		endpoint: `subscriptions/validateNpi`,
		schema: SubscriptionSchema.VALIDATE_NPI,
		query,
		mapActionToStateKey: 'npiDetails'
	}
});

const fetchHPDAddresses = (query) => (dispatch) => dispatch({
	[CALL_SORTED_API]: {
		types: ['HPD_DETAILS_REQUEST', 'HPD_DETAILS_SUCCESS', 'HPD_DETAILS_FAILURE'],
		endpoint: `subscriptions/hpdDirectAddresses`,
		schema: SubscriptionSchema.HPD_DETAILS,
		query,
		mapActionToStateKey: 'hpdDetails'
	}
});

const SubscriptionActionTypes = {
	GET_SUBSCRIPTIONS,
	SUBSCRIPTION_OPT_IN,
	SUBSCRIPTION_OPT_OUT,
	SUBSCRIPTION_DELETE
};

export {
	SubscriptionActionTypes,
	createSubscription,
	createSubscriptions,
	createAdhocSubscription,
	deleteSubscription,
	deleteSubscriptionWithStatus,
	fetchSubscriptions,
	subscriptionOptIn,
	subscriptionOptOut,
	updateSubscription,
	validateAddress,
	validateNPI,
	fetchHPDAddresses,
	sendResubscribeEmail,
	validateSubscription,
	createNPIComment,
	updateNpiComment,
	deleteNpiComment
};
